import { BasicRequest } from "./basicRequest";

export class UndeleteConsolidationDefinitionRequest extends BasicRequest{
    public consolidationDefinitionId! : number;
}